import React from "react";

const Services = () => {
  return (
    <div className="mt-28"id="service">
      <h1 className="text-xl font-bold text-center title">Services</h1>
      <h2 className="text-4xl font-bold text-center text-white">
        What I Do for My Clients
      </h2>

      <section class="mt-20">
        <div class="flex justify-center gap-3">
          <div className=" mx-auto px-10  grid grid-cols-1 md:grid-cols-3 gap-10 ">
            <div
              className="w-72 h-80 p-6 rounded-md shadow-md bg-violet-900 dark:text-gray-50"
              bis_skin_checked="1"data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
            >
              <img
                src="https://webdoorinfotech.com/wp-content/uploads/2020/07/UX.png"
                alt=""
                className="object-cover object-center w-28 mx-auto rounded-md h-28 mt-10"
              />
              <div className="mt-6 mb-2 text-center" bis_skin_checked="1">
                <h2 className="text-2xl font-semibold tracking-wide mt-10">
                  Web Site Development
                </h2>
              </div>
            </div>
            <div
              className="w-72 h-80 p-6 rounded-md shadow-md bg-violet-900 dark:text-gray-50"
              bis_skin_checked="1"data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
            >
              <img
                src="https://www.capturedm.com/wp-content/uploads/2022/10/Artboard-2-copy-3.png"
                alt=""
                className="object-cover object-center w-28 mx-auto rounded-md h-28 mt-10"
              />
              <div className="mt-6 mb-2 text-center" bis_skin_checked="1">
                
                <h2 className="text-2xl font-semibold tracking-wide mt-10">
                Design Full Web Site
                </h2>
              </div>
              
            </div>
            <div
              className="w-72 h-80 p-6 rounded-md shadow-md bg-violet-900 dark:text-gray-50"
              bis_skin_checked="1"data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
            >
              <img
                src="https://marvel-b1-cdn.bc0a.com/f00000000263590/evertz.com/img/applications/radio-frequencies/circle-uplink.png"
                alt=""
                className="object-cover object-center w-28 mx-auto rounded-md h-28 mt-10"
              />
              <div className="mt-6 mb-2 text-center" bis_skin_checked="1">
                <h2 className="text-2xl font-semibold tracking-wide mt-10">
                Front-End Design Web Page
                </h2>
              </div>
             
            </div>
            <div
              className="w-72 h-80 p-6 rounded-md shadow-md bg-violet-900 dark:text-gray-50"
              bis_skin_checked="1"data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
            >
              <img
                src="https://assets.codemonauts.com/Manifest/sattelite.svg?mtime=20180503153325"
                alt=""
                className="object-cover object-center w-28 mx-auto rounded-md h-28 mt-10"
              />
              <div className="mt-6 mb-2 text-center" bis_skin_checked="1">
                <h2 className="text-2xl font-semibold tracking-wide mt-10">
                Back-End Data Management
                </h2>
              </div>
             
            </div>
            <div
              className="w-72 h-80 p-6 rounded-md shadow-md bg-violet-900 dark:text-gray-50"
              bis_skin_checked="1"data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
            >
              <img
                src="https://alt365.my/wp/wp-content/uploads/2019/02/Cloud-Server.png"
                alt=""
                className="object-cover object-center w-36 mx-auto rounded-md h-28 mt-10"
              />
              <div className="mt-6 mb-2 text-center" bis_skin_checked="1">
                <h2 className="text-2xl font-semibold tracking-wide mt-10">
                Server & Cloud Management
                </h2>
              </div>
              
            </div>
            <div
              className="w-72 h-80 p-6 rounded-md shadow-md bg-violet-900 dark:text-gray-50"
              bis_skin_checked="1"data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
            >
              <img
                src="https://www.milesweb.com/img-assets/vps/managed-vps-hosting.png"
                alt=""
                className="object-cover object-center w-28 mx-auto rounded-full h-28 mt-10"
              />
              <div className="mt-6 mb-2 text-center" bis_skin_checked="1">
                
                <h2 className="text-2xl font-semibold tracking-wide mt-10">
                Deploy , Domain & Hosting Support
                </h2>
              </div>
           
            </div>
            
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
